import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { showPmrSuccess, showPmrError, showPmrConfirm } from '../../../utils/swalUtils';
import { showNotificationIfAllowed } from '../../../utils/pushNotification';
import GeneralInfoForm from './generalInfoForm';
import AddressInfoForm from './addressInfoForm';
import FamilyInfoForm from './familyInfo';
//import './AccountSettings.css'; // Import your custom CSS file
import avtarimage from '../../../assets/images/logo/default-user.jpg';
import ViewReports from '../../../components/viewreportslist';
import { User, Info, Users, Shield } from 'react-feather';
import { useSelector, useDispatch } from "react-redux";
import {
    profileUsersDetailsGet, familyRelationsGet, familyMembersUsersGet, familyAccountsGetNew, userDetailsUpdate,
    familyAccountDelete, familyAccountCreate, userPhotoUpload, FamilyAccountUpdateStatus
} from 'apiServices';
// import { notificationsGet, notificationsShown } from 'apiServices/reducer/apiService';
import { CountryCodesGet } from 'apiServices/reducer/apiService';
import { ClientSideRowModelModule } from 'ag-grid-community';
import { AgGridReact } from "ag-grid-react"; 
import { FaCheck, FaTimes, FaChevronDown } from 'react-icons/fa';
import { BiUserMinus, BiUserCheck } from "react-icons/bi";
import Select from 'react-select';
import { FaSearch } from 'react-icons/fa';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import "flatpickr/dist/themes/material_green.css";
import FamilyActionModal from './FamilyActionModal';
import PmrSelect from '../../../components/controls/dropdown/PmrSelect';
import PasskeyRegisterCard from '../../../components/passkey/PasskeyRegisterCard';
// import './accountSettings.css';

const PROFILE_GENDER_OPTIONS = [
    { value: '0', label: 'Male' },
    { value: '1', label: 'Female' },
    { value: '2', label: 'Other' },
];

const styles = `
    .custom-header-class {
        background-color: var(--pmr-grid-header-bg) !important;
        color: var(--pmr-text-heading) !important;
        font-weight: 600 !important;
        border-bottom: 2px solid var(--pmr-border) !important;
    }
    .swal2-error-custom .swal2-icon, .swal2-success-custom .swal2-icon {
        border-color: transparent !important;
    }
    .swal2-error-custom .swal2-icon {
        border-color: #d33 !important;
        border-width: 3px !important;
    }
    .swal2-alert-custom .swal2-icon {
        border: none !important;
        box-shadow: none !important;
        background: transparent !important;
        padding: 0 !important;
    }
    .swal2-alert-custom svg {
        display: block;
        margin: 0 auto;
    }
    
    /* Custom validation styles for red border */
    .form-control.is-invalid {
        border-color: var(--pmr-danger) !important;
        box-shadow: none !important;
    }
    
    .form-control.is-invalid:focus {
        border-color: var(--pmr-danger) !important;
        box-shadow: none !important;
    }
    
    /* Ensure red border is visible */
    .is-invalid {
        border: 1px solid var(--pmr-danger) !important;
        border-radius: 0.375rem !important;
        box-shadow: none !important;
    }
    
    /* Remove border from SweetAlert close icon */
    .swal2-close {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }
    
    .swal2-close:focus {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .account-settings-phone-group .signup-phone-combined {
        display: flex;
        align-items: center;
        overflow: hidden;
        padding: 0 !important;
        height: 42px;
        min-height: 42px;
        border: 1px solid var(--pmr-border-input);
        border-radius: 0.375rem;
        background-color: var(--pmr-white);
        box-sizing: border-box;
    }

    .account-settings-phone-group .signup-phone-country-select {
        flex: 0 0 3.5rem;
        width: 3.5rem;
        min-width: 3.5rem;
        max-width: 3.5rem;
        height: 42px !important;
        min-height: 42px !important;
        max-height: 42px !important;
        margin: 0 !important;
        border: none !important;
        border-right: 1px solid var(--pmr-border-input) !important;
        border-radius: 0 !important;
        padding: 0 1.1rem 0 0.35rem !important;
        font-size: 1rem !important;
        font-weight: 400;
        line-height: 42px !important;
        color: var(--pmr-text);
        background-color: var(--pmr-bg-muted) !important;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 0.4rem center;
        background-size: 12px 9px;
        box-shadow: none !important;
    }

    .account-settings-phone-group .signup-phone-number-input {
        flex: 1 1 0;
        width: 100%;
        min-width: 0;
        height: 42px !important;
        min-height: 42px !important;
        max-height: 42px !important;
        margin: 0 !important;
        border: none !important;
        border-radius: 0 !important;
        padding: 0 0.65rem !important;
        font-size: 1rem !important;
        line-height: 42px !important;
        color: var(--pmr-text);
        background-color: var(--pmr-white) !important;
        box-shadow: none !important;
    }

    .account-settings-phone-group .signup-phone-country-select:focus,
    .account-settings-phone-group .signup-phone-number-input:focus {
        box-shadow: none !important;
        outline: none !important;
    }

    .account-settings-phone-group .signup-phone-combined:focus-within {
        border-color: var(--pmr-primary) !important;
        box-shadow: 0 0 0 0.15rem var(--pmr-primary-focus-ring) !important;
    }

    .account-settings-phone-group .signup-phone-combined.is-invalid:focus-within {
        border-color: var(--pmr-danger) !important;
        box-shadow: 0 0 0 0.15rem rgba(220, 38, 38, 0.25) !important;
    }

    .account-settings-phone-group .signup-phone-combined.is-invalid {
        border-color: var(--pmr-danger) !important;
    }

    .account-settings-phone-group .signup-phone-combined.is-invalid .signup-phone-country-select {
        border-right-color: var(--pmr-danger) !important;
    }

    .account-settings-phone-group .signup-field-validation-icon {
        position: absolute;
        top: 50%;
        right: 0.65rem;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        pointer-events: none;
        z-index: 2;
        font-size: 1rem;
        line-height: 1;
    }

    .account-settings-phone-group .pmr-select-embedded {
        width: auto;
        min-width: 4.5rem;
        max-width: 5.5rem;
        flex: 0 0 auto;
    }

    .account-settings-phone-group .pmr-select-embedded .pmr-select__control {
        width: auto !important;
        min-width: 4.5rem !important;
    }

    .profile-image-preview-popup {
        width: fit-content !important;
        max-width: 90vw !important;
        padding: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        overflow: visible !important;
    }

    .profile-image-preview-popup .swal2-image {
        width: auto;
        height: auto;
        max-width: 90vw;
        max-height: 80vh;
        object-fit: contain;
        border-radius: 8px;
        margin: 0;
    }

    .profile-image-preview-popup .swal2-close {
        position: absolute !important;
        top: -30px !important;
        right: -16px !important;
        width: 32px !important;
        height: 32px !important;
        min-height: 32px !important;
        background: transparent !important;
        color: #ffffff !important;
        font-size: 24px !important;
        line-height: 32px !important;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8) !important;
    }

    /* Account settings tabs — match theme coral */
    #page-account-settings .nav-left .activeclass.active {
        background: var(--pmr-primary) !important;
        color: var(--pmr-white) !important;
        box-shadow: 0 4px 18px -4px var(--pmr-primary-shadow);
    }

    /* Cancel button — theme coral, stable hover (no black override) */
    #page-account-settings .btn.account-settings-cancel-btn,
    #page-account-settings .btn.account-settings-cancel-btn:hover,
    #page-account-settings .btn.account-settings-cancel-btn:focus,
    #page-account-settings .btn.account-settings-cancel-btn:active {
        background-color: var(--pmr-primary) !important;
        border-color: var(--pmr-primary) !important;
        color: var(--pmr-white) !important;
        box-shadow: none !important;
    }

    #page-account-settings .btn.account-settings-cancel-btn:hover {
        background-color: var(--pmr-primary-hover) !important;
        border-color: var(--pmr-primary-hover) !important;
    }

    /* react-select dropdown — theme colors instead of default blue */
    .pmr-select__option--is-focused {
        background-color: var(--pmr-primary-light) !important;
        color: var(--pmr-text) !important;
    }

    .pmr-select__option--is-selected {
        background-color: var(--pmr-primary) !important;
        color: var(--pmr-white) !important;
    }

    .pmr-select__option--is-selected.pmr-select__option--is-focused {
        background-color: var(--pmr-primary) !important;
        color: var(--pmr-white) !important;
    }

    .pmr-select__control--is-focused {
        border-color: var(--pmr-primary) !important;
        box-shadow: 0 0 0 0.15rem var(--pmr-primary-focus-ring) !important;
    }

    .pmr-select__control:hover:not(.pmr-select__control--is-focused) {
        border-color: var(--pmr-border-input) !important;
        box-shadow: none !important;
    }

    #page-account-settings select.form-control:focus {
        border-color: var(--pmr-primary) !important;
        box-shadow: 0 0 0 0.15rem var(--pmr-primary-focus-ring) !important;
    }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

// Function to format date to MM/DD/YYYY format
const formatDateToMMDDYYYY = (dateString) => {
    if (!dateString) return '';

    try {
        // Handle different date formats that might come from API
        let date;

        // If it's already in MM/DD/YYYY format, return as is
        if (typeof dateString === 'string' && dateString.includes('/')) {
            return dateString;
        }

        // Handle ISO date strings (remove time part if present)
        if (typeof dateString === 'string' && dateString.includes('T')) {
            dateString = dateString.split('T')[0];
        }

        date = new Date(dateString);
        if (isNaN(date.getTime())) return '';

        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};

// Function to convert MM/DD/YYYY format to YYYY-MM-DD format for API
const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return '';

    try {
        // Handle MM/DD/YYYY format
        const parts = dateString.split('/');
        if (parts.length === 3) {
            const month = parts[0];
            const day = parts[1];
            const year = parts[2];
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        // If it's already in YYYY-MM-DD format, return as is
        return dateString;
    } catch (error) {
        console.error('Error converting date format:', error);
        return dateString;
    }
};

/** Parse MM/DD/YYYY (or Date) to a Date for Flatpickr — avoids empty display */
const parseDobForPicker = (value) => {
    if (!value) return null;
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed) return null;

    const slashParts = trimmed.split('/');
    if (slashParts.length === 3) {
        const month = parseInt(slashParts[0], 10);
        const day = parseInt(slashParts[1], 10);
        const year = parseInt(slashParts[2], 10);
        if (!month || !day || !year) return null;
        const date = new Date(year, month - 1, day);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const iso = trimmed.includes('T') ? trimmed.split('T')[0] : trimmed;
    const dashParts = iso.split('-');
    if (dashParts.length === 3) {
        const year = parseInt(dashParts[0], 10);
        const month = parseInt(dashParts[1], 10);
        const day = parseInt(dashParts[2], 10);
        if (!month || !day || !year) return null;
        const date = new Date(year, month - 1, day);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const fallback = new Date(trimmed);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
};

const sanitizePhone = (value) => String(value || '').replace(/[^0-9]/g, '').slice(0, 10);

const validatePhone = (phone, requireComplete = false) => {
    if (!phone) {
        if (requireComplete) return { isValid: false, message: 'Please enter 10 digits' };
        return { isValid: true, message: '' };
    }
    if (!/^\d+$/.test(phone)) return { isValid: false, message: 'Phone number must contain only digits' };
    if (phone.length > 10) return { isValid: false, message: 'Please enter 10 digits' };
    if (requireComplete && phone.length !== 10) return { isValid: false, message: 'Please enter 10 digits' };
    return { isValid: true, message: '' };
};

const findFirstArrayInObject = (obj) => {
    if (!obj || typeof obj !== 'object') return null;
    for (const value of Object.values(obj)) {
        if (Array.isArray(value)) return value;
    }
    for (const value of Object.values(obj)) {
        if (value && typeof value === 'object') {
            for (const nested of Object.values(value)) {
                if (Array.isArray(nested)) return nested;
            }
        }
    }
    return null;
};

const normalizeCountryCodeOptions = (payload) => {
    const rows =
        payload?.Table ??
        payload?.table ??
        payload?.Data ??
        payload?.data?.Table ??
        payload?.data?.table ??
        (Array.isArray(payload) ? payload : null) ??
        findFirstArrayInObject(payload) ??
        [];

    if (!Array.isArray(rows)) return [];

    const options = rows
        .map((row) => {
            // API can return: ["+1", "+91"] or [{...}]
            if (typeof row === 'string' || typeof row === 'number') {
                const digits = String(row).replace(/[^\d]/g, '');
                if (!digits) return null;
                const value = `+${digits}`;
                return { value, label: value };
            }

            const codeRaw =
                row?.country_code ??
                row?.CountryCode ??
                row?.dial_code ??
                row?.DialCode ??
                row?.phone_code ??
                row?.PhoneCode ??
                row?.code ??
                row?.Code;

            if (codeRaw == null || codeRaw === '') return null;
            const digits = String(codeRaw).replace(/[^\d]/g, '');
            if (!digits) return null;
            const value = `+${digits}`;
            return { value, label: value };
        })
        .filter(Boolean);

    const uniq = new Map();
    for (const o of options) uniq.set(o.value, o);
    return Array.from(uniq.values()).sort((a, b) => Number(a.value.slice(1)) - Number(b.value.slice(1)));
};

// Used when API options are not loaded yet (longest match first)
const DEFAULT_DIAL_CODES = ['+971', '+91', '+61', '+44', '+1'];

const normalizePhoneRaw = (raw) => {
    const s = String(raw || '').trim();
    if (!s) return '';
    if (s.startsWith('+')) return s;
    const digits = s.replace(/[^\d]/g, '');
    return digits ? `+${digits}` : '';
};

const splitPhoneFromApi = (raw, countryCodeOptions) => {
    const s = normalizePhoneRaw(raw);
    if (!s) return { phone_country_code: '+1', phone: '' };

    // NANP: +1 + exactly 10 digits (e.g. +15557778888)
    const nanp = s.match(/^\+1(\d{10})$/);
    if (nanp) return { phone_country_code: '+1', phone: nanp[1] };

    const optionCodes = Array.isArray(countryCodeOptions)
        ? countryCodeOptions.map((o) => o?.value).filter(Boolean)
        : [];

    const codes = [...new Set([...optionCodes, ...DEFAULT_DIAL_CODES])].sort(
        (a, b) => b.length - a.length,
    );
    const match = codes.find((code) => s.startsWith(code));
    if (match) {
        return { phone_country_code: match, phone: sanitizePhone(s.slice(match.length)) };
    }

    const fallback = s.match(/^\+(\d{1,3})(.*)$/);
    if (fallback) {
        return { phone_country_code: `+${fallback[1]}`, phone: sanitizePhone(fallback[2]) };
    }
    return { phone_country_code: '+1', phone: sanitizePhone(s) };
};

const formatFullPhone = (countryCode, phone) => {
    const cc = String(countryCode || '').trim() || '+1';
    const digits = sanitizePhone(phone);
    if (!digits) return '';
    return `${cc}${digits}`;
};

const escapeHtml = (str) =>
    String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

function readProfilePushNotice(payload) {
    let body = payload?.data ?? payload;
    if (typeof body === 'string') {
        const trimmed = body.replace(/^\uFEFF/, '').trim();
        if (!trimmed.startsWith('{')) return null;
        try {
            body = JSON.parse(trimmed);
        } catch (e) {
            return null;
        }
    }
    if (body && typeof body === 'object' && (body.title || body.message || body.comments)) {
        return body;
    }
    return null;
}

const MIN_FAMILY_MEMBER_SEARCH_LENGTH = 3;

const formatPayloadQuotedBold = (message) => {
    if (message == null || message === '') return '';
    const s = String(message);
    let out = '';
    let i = 0;
    while (i < s.length) {
        const q = s.indexOf('"', i);
        if (q === -1) {
            out += escapeHtml(s.slice(i));
            break;
        }
        out += escapeHtml(s.slice(i, q));
        const q2 = s.indexOf('"', q + 1);
        if (q2 === -1) {
            out += escapeHtml(s.slice(q));
            break;
        }
        const inner = s.slice(q + 1, q2);
        out += `"<strong>${escapeHtml(inner)}</strong>"`;
        i = q2 + 1;
    }
    return out;
};

const AccountSettings = (props) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.apiService.login);
    // console.log(userData, "token");
    const token = useSelector((state) => state.apiService.token);
    const params = { token, user_id: userData.user_id };
    const [accountSettings, setaccountSettings] = useState([]);
    const [generalForm, setGeneralForm] = useState({
        first_name: '',
        last_name: '',
        gender: '',
        date_of_birth: '',
        phone: '',
        phone_country_code: '+1',
        alternate_email: ''
    });
    const [addressForm, setAddressForm] = useState({
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
    });
    // console.log(addressForm, "addressForm");
    const [familyForm, setFamilyForm] = useState({
        patient_name: '',
        relation: '',
        patient_id: ''
    });
    const [avatarImage, setAvatarImage] = useState(avtarimage);
    const [generalSubmitted, setGeneralSubmitted] = useState(false);
    const [generalPhoneValidation, setGeneralPhoneValidation] = useState({ isValid: true, message: '' });
    const [addressSubmitted, setAddressSubmitted] = useState(false);
    const [familySubmitted, setFamilySubmitted] = useState(false);
    const [activeTab, setActiveTab] = useState('general');
    const [countryCodeOptions, setCountryCodeOptions] = useState([]);
    const [userPhoneRaw, setUserPhoneRaw] = useState('');
    const [familyOptions, setFamilyOptions] = useState([]);
    const [familySearchInput, setFamilySearchInput] = useState('');
    const [relationOptions, setRelationOptions] = useState([]);
    const [familyMembers, setFamilyMembers] = useState([]);
    const [showFamilyModal, setShowFamilyModal] = useState(false);
    const [familyModalMessage, setFamilyModalMessage] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [showActionModal, setShowActionModal] = useState(false);
    const [selectedFamilyData, setSelectedFamilyData] = useState(null);
    const [isProcessingAction, setIsProcessingAction] = useState(false);
    const [formData, setFormData] = useState({
        Imagepath: '',
        UserID: userData.user_id,
        token: token,
        section: 'general'
    });

    const familyColumns = [
        {
            headerName: 'Remove',
            field: 'remove',
            filter: false,
            flex: 0.7,
            cellClass: 'griddata-label',
            headerTooltip: 'Remove',
            cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
            sortable: false,
            cellRenderer: (params) => (
                <BiUserMinus
                    className="text-danger-500 mx-auto d-flex justify-content-center align-items-center"
                    size={25}
                    color="red"
                    onClick={() => handleRemoveMember(params.data.FamilyAccountID)}
                />
            )
        },
        {
            headerName: 'Name',
            field: 'relativeName',
            flex: 1.5,
            filter: 'agTextColumnFilter',
            cellClass: 'griddata-label',
            tooltipField: 'relativeName',
            headerTooltip: 'Name',
            cellStyle: { display: 'flex', alignItems: 'center' }
        },
        {
            headerName: 'Relation',
            field: 'relationTypeName',
            flex: 1,
            tooltipField: 'relationTypeName',
            headerTooltip: 'Relation',
            filter: 'agTextColumnFilter',
            cellClass: 'griddata-label',
            cellStyle: { display: 'flex', alignItems: 'center' }
        },
        {
            headerName: 'Requested on',
            field: 'requestOn',
            flex: 1.2,
            tooltipField: 'requestOn',
            headerTooltip: 'Requested on',
            cellClass: 'griddata-label',
            cellStyle: { display: 'flex', alignItems: 'center' },
            valueFormatter: (params) => {
                if (params.value) {
                    return params.value;
                }
                return '';
            }
        },
        {
            headerName: 'Approved',
            field: 'approved',
            flex: 0.9,
            headerTooltip: 'Approved',
            cellClass: 'griddata-label',
            cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
            filter: false,
            sortable: false,
            cellRenderer: (params) => {
                if (params.value === true) {
                    // Approved - show green checkmark
                    return (
                        <span className="text-success">
                            <FaCheck
                                className="mx-auto d-flex justify-content-center align-items-center"
                                size={14}
                                color="green"
                            />
                        </span>
                    );
                } else if (params.value === false && params.data.requesterUserID !== null) {
                    // Rejected - show red cross for all rejected requests where current user is not the requester
                    return (
                        <span className="text-danger">
                            <FaTimes
                                className="mx-auto d-flex justify-content-center align-items-center"
                                size={14}
                                color="var(--pmr-danger)"
                            />
                        </span>
                    );
                } else if (params.value === null || params.value === undefined) {
                    // Pending (Later clicked or no action taken) - show nothing
                    return <span></span>;
                } else {
                    // Default case - show nothing
                    return <span></span>;
                }
            }
        },
        {
            headerName: 'Approved on',
            field: 'approvedOn',
            flex: 1.2,
            tooltipField: 'approvedOn',
            headerTooltip: 'Approved on',
            cellClass: 'griddata-label',
            cellStyle: { display: 'flex', alignItems: 'center' },
            valueFormatter: (params) => {
                if (params.value) {
                    return params.value;
                }
                return '';
            }
        },
        {
            headerName: 'Action',
            filter: false,
            field: '',
            flex: 0.7,
            tooltipField: 'action',
            headerTooltip: 'Action',
            cellClass: 'griddata-label',
            cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
            sortable: false,
            cellRenderer: (params) => {
                // Show BiUserCheck icon only when:
                // 1. Status is pending (null/undefined) OR rejected (false)
                // 2. AND requested_by is NOT null (meaning current user is NOT the requester)
                if (params.data &&
                    (params.data.approved === null || params.data.approved === undefined || params.data.approved === false) &&
                    params.data.requesterUserID !== null) {
                    return (
                        <BiUserCheck
                            size={22}
                            color="green"
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
                            onClick={() => handleApproveAccess(params.data)}
                        />
                    );
                }
                // Return empty div when approved is true OR when current user sent the request (requested_by is null)
                return <div></div>;
            }
        }
    ];

    const fetchAndSetFamilyAccounts = () => {
        dispatch(familyAccountsGetNew(params))
            .then((response) => {
                if (response.payload && Array.isArray(response.payload.Table)) {
                    // Debug: Log the first item to see available fields
                    if (response.payload.Table.length > 0) {
                    }

                    const combinedData = response.payload.Table.map((report) => ({
                        relationTypeName: report.relation_type_name || '',
                        relativeName: report.relative_name || '',
                        approved: report.is_approved === null || report.is_approved === undefined ? null : report.is_approved,
                        approvedOn: report.approved_on || '',
                        requestOn: report.created_on || '',
                        FamilyAccountID: report.family_account_id,
                        relativeUserID: report.user_id, // Use user_id as relativeUserID
                        requesterUserID: report.requested_by, // Use requested_by directly (null means current user is requester)
                    }));
                    setaccountSettings(combinedData);
                } else {
                    setaccountSettings([]);
                }
            })
            .catch(() => setaccountSettings([]));
    };
    const handleRemoveMember = (FamilyAccountID) => {
        showPmrConfirm({
            title: 'Are you sure?',
            message: 'You want to remove family member',
        }).then((result) => {
            if (result.isConfirmed) {
                const deletePayload = {
                    FamilyAccountID,
                    user_id: userData.user_id,
                    token: userData.token
                };
                dispatch(familyAccountDelete(deletePayload))
                    .then((response) => {
                        if (response && !response.error) {
                            showPmrSuccess({
                                message: 'Family member has been removed successfully.',
                                timer: 2000,
                            });
                            fetchAndSetFamilyAccounts();
                            fetchFamilyMemberOptions();
                            fetchRelationOptions();
                        } else {
                            showPmrError('Failed to remove family member.');
                        }
                    });
            }
        });
    };

    const fetchRelationOptions = () => {
        dispatch(familyRelationsGet(params))
            .then((response) => {
                if (response.payload && response.payload.Table) {
                    const relations = response.payload.Table.map(relation => ({
                        value: relation.relation_type_id,
                        label: relation.relation_type_name
                    }));
                    setRelationOptions(relations);
                }
            })
            .catch((error) => {
                console.error("Error fetching relation options:", error);
            });
    };

    const fetchFamilyMemberOptions = () => {
        dispatch(familyMembersUsersGet(params))
            .then((response) => {
                if (response.payload && response.payload.Table) {
                    const members = response.payload.Table.map(member => ({
                        value: member.user_id,
                        label: `${member.name} [${member.user_name}]`
                    }));
                    setFamilyOptions(members);
                }
            })
            .then(() => {
            })
            .catch((error) => {
            });
    };

    useEffect(() => {
        let cancelled = false;

        const loadProfile = async () => {
            let codeOptions = [];
            try {
                const ccResponse = await dispatch(CountryCodesGet()).unwrap();
                codeOptions = normalizeCountryCodeOptions(ccResponse);
                if (!cancelled) {
                    setCountryCodeOptions(codeOptions);
                }
            } catch (error) {
                console.error('Error fetching country codes:', error);
            }

            try {
                const response = await dispatch(profileUsersDetailsGet(params));
                if (cancelled) return;
                if (response.payload && response.payload.Table && response.payload.Table.length > 0) {
                    const userDetails = response.payload.Table[0];
                    const rawPhone = userDetails.phone || '';
                    setUserPhoneRaw(rawPhone);
                    const splitPhone = splitPhoneFromApi(rawPhone, codeOptions);

                    setGeneralForm({
                        first_name: userDetails.first_name || '',
                        last_name: userDetails.last_name || '',
                        gender: userDetails.gender?.toString() || '',
                        date_of_birth: userDetails.dob ? formatDateToMMDDYYYY(userDetails.dob) : '',
                        phone: splitPhone.phone,
                        phone_country_code: splitPhone.phone_country_code,
                        alternate_email: userDetails.alternate_email || '',
                        image_path: userDetails.Image_path,
                    });
                    // Set address form data
                    setAddressForm({
                        address1: userDetails.add1 || '',
                        address2: userDetails.add2 || '',
                        city: userDetails.city || '',
                        state: userDetails.state || '',
                        zip: userDetails.zip || '',
                        country: userDetails.country || ''
                    });

                    // Set avatar image if available
                    if (userDetails.Image_path) {
                        setAvatarImage(userDetails.Image_path);
                    }
                }
            } catch (error) {
                console.error("Error fetching usersDetailsGet:", error);
            }
        };

        loadProfile();
        fetchAndSetFamilyAccounts();
        fetchRelationOptions();
        fetchFamilyMemberOptions();

        return () => {
            cancelled = true;
        };
    }, []);

    // When country code options arrive, re-split the saved phone accurately (prevents +9198 type mismatches)
    useEffect(() => {
        if (!userPhoneRaw) return;
        if (!Array.isArray(countryCodeOptions) || countryCodeOptions.length === 0) return;

        const split = splitPhoneFromApi(userPhoneRaw, countryCodeOptions);
        setGeneralForm((prev) => {
            if (prev.phone === split.phone && prev.phone_country_code === split.phone_country_code) return prev;
            return { ...prev, phone: split.phone, phone_country_code: split.phone_country_code };
        });
    }, [userPhoneRaw, countryCodeOptions]);

    const fileInputRef = useRef(null);

    const handleUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        // Validate file type
        const validTypes = ["image/jpeg", "image/png", "image/gif"];
        if (!validTypes.includes(file.type)) {
            showPmrError('Only JPG, PNG, or GIF files are allowed.');
            return;
        }
        // Validate file size (max 800KB)
        if (file.size > 800 * 1024) {
            showPmrError('Maximum file size is 800KB.');
            return;
        }

        // Show preview and store the image data URL
        const reader = new FileReader();
        let uploadedImageUrl = '';
        reader.onloadend = () => {
            uploadedImageUrl = reader.result;
            setAvatarImage(uploadedImageUrl);
        };
        reader.readAsDataURL(file);

        // Upload the file
        setIsUploading(true);

        formData.Imagepath = file;
        dispatch(userPhotoUpload(formData))
            .then((response) => {
                if (response && response.payload) {
                    showPmrSuccess({
                        message: 'Photo uploaded successfully!',
                        timer: 2000,
                    }).then(() => {
                        // Dispatch notification update event to refresh notifications immediately
                        const event = new Event('notificationsUpdated');
                        document.dispatchEvent(event);

                        // Dispatch custom event to update header profile image immediately
                        const profileUpdateEvent = new CustomEvent('profileNameUpdated', {
                            detail: {
                                first_name: generalForm.first_name,
                                last_name: generalForm.last_name,
                                image_path: uploadedImageUrl // Use the stored uploaded image data URL
                            }
                        });
                        document.dispatchEvent(profileUpdateEvent);
                    });
                } else {
                    throw new Error('Upload failed');
                }
            })
            .catch((error) => {
                console.error("Error uploading photo:", error);
                showPmrError('Failed to upload photo. Please try again.');
                // Reset to previous image on error
                setAvatarImage(avtarimage);
            })
            .finally(() => {
                setIsUploading(false);
            });
    };

    // Simplified upload click handler
    const handleUploadClick = () => {

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
            fileInputRef.current.click();
        }
    };

    const handleAvatarPreview = () => {
        if (!avatarImage) return;

        Swal.fire({
            imageUrl: avatarImage,
            imageAlt: 'Profile preview',
            showCloseButton: true,
            showConfirmButton: false,
            background: 'transparent',
            width: 'fit-content',
            padding: 0,
            customClass: {
                popup: 'profile-image-preview-popup'
            }
        });
    };

    const handleGeneralChange = (e) => {
        const { name, value } = e.target;

        if (name === 'phone_country_code') {
            setGeneralForm({ ...generalForm, phone_country_code: value });
            return;
        }
        if (name === 'phone') {
            const numericValue = sanitizePhone(value);
            setGeneralForm({ ...generalForm, phone: numericValue });
            setGeneralPhoneValidation(validatePhone(numericValue));
            return;
        }
        // For first name and last name fields, only allow alphabets and spaces
        else if (name === 'first_name' || name === 'last_name') {
            // Remove any non-alphabetic characters (except spaces)
            const alphabeticValue = value.replace(/[^a-zA-Z\s]/g, '');
            setGeneralForm({ ...generalForm, [name]: alphabeticValue });
        } else {
            setGeneralForm({ ...generalForm, [name]: value });
        }
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;

        // For zip field, only allow numbers
        if (name === 'zip') {
            // Remove any non-numeric characters
            const numericValue = value.replace(/[^0-9]/g, '');
            setAddressForm(prev => ({
                ...prev,
                [name]: numericValue
            }));
        } else {
            setAddressForm(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleFamilyChange = (e) => {
        const { name, value } = e.target;
        setFamilyForm({ ...familyForm, [name]: value });
    };


    const handleGeneralSubmit = (e) => {
        e.preventDefault();
        setGeneralSubmitted(true);

        const phoneValidation = validatePhone(generalForm.phone, Boolean(generalForm.phone));
        setGeneralPhoneValidation(phoneValidation);

        // Validate required fields
        if (
            !generalForm.first_name ||
            !generalForm.last_name ||
            !phoneValidation.isValid ||
            !generalForm.gender
        ) {
            // Swal.fire({
            //     title: 'Error',
            //     text: 'Please fill in all required fields',
            //     iconHtml: customErrorSVG,
            //     confirmButtonText: 'OK'
            // });
            return;
        }

        // Validate alternate email format (optional field, only validate if provided)
        if (generalForm.alternate_email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(generalForm.alternate_email)) {
                return;
            }
        }

        // Prepare the update payload
        const updatePayload = {
            ...params,
            first_name: generalForm.first_name,
            last_name: generalForm.last_name,
            gender: generalForm.gender,
            date_of_birth: formatDateToYYYYMMDD(generalForm.date_of_birth),
            phone: formatFullPhone(generalForm.phone_country_code, generalForm.phone),
            alternate_email: generalForm.alternate_email,
            section: 'general'
        };

        // Call the update API
        dispatch(userDetailsUpdate(updatePayload))
            .then((response) => {
                if (response.payload) {
                    const pushNotice = readProfilePushNotice(response.payload);
                    const rawBody = response.payload?.data ?? response.payload;
                    const successText = pushNotice
                        ? (pushNotice.message || pushNotice.comments || 'Your profile has been updated')
                        : (typeof rawBody === 'string' ? rawBody : 'Your profile has been updated');
                    // Show success message
                    showPmrSuccess({
                        html: formatPayloadQuotedBold(successText),
                        timer: 2000,
                    }).then(() => {
                        // Dispatch notification update event to refresh notifications immediately
                        const event = new Event('notificationsUpdated');
                        document.dispatchEvent(event);

                        // Dispatch custom event to update header profile name and image immediately
                        const profileUpdateEvent = new CustomEvent('profileNameUpdated', {
                            detail: {
                                first_name: generalForm.first_name,
                                last_name: generalForm.last_name,
                                image_path: avatarImage,
                                alternate_email: generalForm.alternate_email
                            }
                        });
                        document.dispatchEvent(profileUpdateEvent);
                    });

                    if (pushNotice) {
                        showNotificationIfAllowed({
                            userId: userData?.user_id,
                            token: token || userData?.Token,
                            title: pushNotice.title || 'Your profile has been updated',
                            body: pushNotice.message || pushNotice.comments || 'Your profile has been updated',
                            url: pushNotice.url || window.location.href,
                            tag: `pmr-profile-${Date.now()}`,
                        }).catch(() => {});
                    }

                    // Refresh user details
                    dispatch(profileUsersDetailsGet(params))
                        .then((userDetailsResponse) => {
                            if (userDetailsResponse.payload && userDetailsResponse.payload.Table && userDetailsResponse.payload.Table.length > 0) {
                                const userDetails = userDetailsResponse.payload.Table[0];
                                const rawPhone = userDetails.phone || '';
                                setUserPhoneRaw(rawPhone);
                                const splitPhone = splitPhoneFromApi(rawPhone, countryCodeOptions);
                                setGeneralForm((prev) => ({
                                    ...prev,
                                    first_name: userDetails.first_name || '',
                                    last_name: userDetails.last_name || '',
                                    gender: userDetails.gender?.toString() || '',
                                    date_of_birth: userDetails.dob ? formatDateToMMDDYYYY(userDetails.dob) : '',
                                    phone: splitPhone.phone,
                                    phone_country_code: splitPhone.phone_country_code,
                                    alternate_email: userDetails.alternate_email || '',
                                    image_path: userDetails.Image_path || prev.image_path,
                                }));
                            }
                        })
                        .catch((error) => {
                            console.error("Error refreshing user details:", error);
                        });
                }
            })
            .catch((error) => {
                console.error("Error updating user details:", error);

            });
    };

    const handleAddressSubmit = (e) => {
        e.preventDefault();
        setAddressSubmitted(true);
        if (
            !addressForm.address1 ||
            !addressForm.city ||
            !addressForm.state ||
            !addressForm.zip ||
            !addressForm.country
        ) {
            return;
        }
        // Prepare the update payload
        const updatePayload = {
            ...params,
            address1: addressForm.address1,
            address2: addressForm.address2,
            city: addressForm.city,
            state: addressForm.state,
            zip: addressForm.zip,
            country: addressForm.country,
            section: 'address'
        };
        // Call the update API
        dispatch(userDetailsUpdate(updatePayload))
            .then((response) => {
                if (response.payload) {
                    const pushNotice = readProfilePushNotice(response.payload);
                    // Show success message
                    showPmrSuccess({
                        message: 'Address Information updated successfully',
                        timer: 2000,
                    }).then(() => {
                        if (pushNotice) {
                            showNotificationIfAllowed({
                                userId: userData?.user_id,
                                token: token || userData?.Token,
                                title: pushNotice.title || 'Your profile has been updated',
                                body: pushNotice.message || pushNotice.comments || 'Address Information updated successfully',
                                url: pushNotice.url || window.location.href,
                                tag: `pmr-address-${Date.now()}`,
                            }).catch(() => {});
                        }
                        // Dispatch notification update event to refresh notifications immediately
                        const event = new Event('notificationsUpdated');
                        document.dispatchEvent(event);

                        // Refresh user details only once after successful update
                        return dispatch(profileUsersDetailsGet(params));
                    })
                        .then((userDetailsResponse) => {
                            if (userDetailsResponse.payload && userDetailsResponse.payload.Table && userDetailsResponse.payload.Table.length > 0) {
                                const userDetails = userDetailsResponse.payload.Table[0];
                                // Update the form state with the new data
                                setAddressForm({
                                    address1: userDetails.add1 || '',
                                    address2: userDetails.add2 || '',
                                    city: userDetails.city || '',
                                    state: userDetails.state || '',
                                    zip: userDetails.zip || '',
                                    country: userDetails.country || ''
                                });
                                // Reset the submitted state
                                setAddressSubmitted(false);
                            }
                        })
                        .catch((error) => {
                            console.error("Error refreshing user details:", error);

                        });
                }
            })
            .catch((error) => {
                console.error("Error updating address details:", error);

            });
    };

    const handleCancle = (e) => {
        e.preventDefault();
        setGeneralSubmitted(false);
        setAddressSubmitted(false);
        setFamilySubmitted(false);

        // Navigate to dashboard by calling the parent's navigation function
        if (props.onViewReportsClick) {
            // Call the navigation function with dashboard menu_id
            props.onViewReportsClick({ menu_id: 1, parent_id: null });
        }
    };

    const handleApproveAccess = (rowData) => {
        setSelectedFamilyData({
            family_account_id: rowData.FamilyAccountID,
            relative_name: rowData.relativeName,
            relation_type_name: rowData.relationTypeName
        });
        setShowActionModal(true);
    };

    const handleApprove = () => {
        if (!selectedFamilyData) return;

        setIsProcessingAction(true);
        const formData = {
            IsApproved: true,
            FamilyAccountID: selectedFamilyData.family_account_id,
            LoginUserID: userData.user_id,
            token: token
        };

        dispatch(FamilyAccountUpdateStatus(formData))
            .then((response) => {
                if (response && response.payload) {
                    showPmrSuccess({
                        message: 'Approved access successfully',
                        timer: 2000,
                    });
                    setShowActionModal(false);
                    fetchAndSetFamilyAccounts();
                } else {
                    throw new Error('Approval failed');
                }
            })
            .catch((error) => {
                console.error("Error approving access:", error);
                showPmrError('Something went wrong');
            })
            .finally(() => {
                setIsProcessingAction(false);
            });
    };

    const handleReject = () => {
        if (!selectedFamilyData) return;

        setIsProcessingAction(true);
        const formData = {
            IsApproved: false,
            FamilyAccountID: selectedFamilyData.family_account_id,
            LoginUserID: userData.user_id,
            token: token
        };

        dispatch(FamilyAccountUpdateStatus(formData))
            .then((response) => {
                if (response && response.payload) {
                    showPmrSuccess({
                        message: 'Rejected access successfully',
                        timer: 2000,
                    });
                    setShowActionModal(false);
                    fetchAndSetFamilyAccounts();
                } else {
                    throw new Error('Rejection failed');
                }
            })
            .catch((error) => {
                console.error("Error rejecting access:", error);
                showPmrError('Something went wrong');
            })
            .finally(() => {
                setIsProcessingAction(false);
            });
    };

    // Add custom styles for select elements
    const selectStyles = {
        position: 'relative',
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        backgroundImage: 'none',
        paddingRight: '30px',
        color: 'var(--pmr-text-muted)', // Default placeholder color
        '&:invalid': {
            color: 'var(--pmr-text-muted)' // Keep placeholder color when no value selected
        }
    };



    const selectWrapperStyles = {
        position: 'relative',
        display: 'inline-block',
        width: '100%'
    };

    const iconStyles = {
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
        color: 'var(--pmr-text-muted)'
    };

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            minWidth: '200px',
            minHeight: '28px',
            backgroundColor: 'var(--pmr-white)',
            border: '1px solid var(--pmr-border)',
            borderRadius: '8px',
            overflow: 'hidden',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (provided, state) => ({
            ...provided,
            minHeight: '38px',
            borderRadius: '8px',
            boxShadow: state.isFocused ? '0 0 0 0.15rem var(--pmr-primary-focus-ring)' : 'none',
            borderColor: state.selectProps.isInvalid
                ? 'var(--pmr-danger)'
                : state.isFocused
                    ? 'var(--pmr-primary)'
                    : 'var(--pmr-border-input)',
            '&:hover': {
                borderColor: state.selectProps.isInvalid
                    ? 'var(--pmr-danger)'
                    : state.isFocused
                        ? 'var(--pmr-primary)'
                        : 'var(--pmr-border-input)',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? 'var(--pmr-primary)'
                : state.isFocused
                    ? 'var(--pmr-primary-light)'
                    : 'var(--pmr-white)',
            color: state.isSelected ? 'var(--pmr-white)' : 'var(--pmr-text)',
            cursor: 'pointer',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'var(--pmr-text)',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: 'var(--pmr-text-muted)',
        }),
    };

    const handleSaveChanges = (e) => {
        e.preventDefault();
        setFamilySubmitted(true);

        // Validate required fields
        if (!familyForm.patient_id || !familyForm.relation) {
            return;
        }

        // Map the form values to match API parameters
        const formBody = {
            token: token,
            user_id: userData.user_id,
            RelationTypeID: parseInt(familyForm.relation), // Convert to number since relation is the ID
            RelativeUserID: parseInt(familyForm.patient_id), // This is the selected family member's ID
            UserID: userData.user_id // Current user's ID
        };

        // console.log("API Request Body:", formBody);

        dispatch(familyAccountCreate(formBody))
            .then((response) => {
                if (response && response.payload) {
                    // Show success message with the output message or a default message
                    showPmrSuccess({
                        message: response.payload.data.OutputMessage || 'Family member added successfully',
                        timer: 1000,
                    }).then(() => {
                        setFamilyForm({
                            relation: '',
                            patient_id: ''
                        });
                        setFamilySubmitted(false);

                        // Add the new family member to the grid data
                        const newFamilyMember = {
                            FamilyAccountID: response.payload.FamilyAccountID,
                            relativeName: familyOptions.find(opt => opt.value === familyForm.patient_id)?.label || '',
                            relationTypeName: relationOptions.find(opt => opt.value === familyForm.relation)?.label || '',
                            approved: response.payload.IsApproved,
                            approvedOn: response.payload.UpdatedOn !== "0001-01-01T00:00:00" ? response.payload.UpdatedOn : '',
                            requestOn: new Date().toISOString().split('T')[0]
                        };

                        // Update the grid data
                        setaccountSettings(prevData => [...prevData, newFamilyMember]);

                        // Also refresh the full list from server to ensure consistency
                        fetchAndSetFamilyAccounts();
                    });
                }
            })
            .catch((error) => {
                console.error("Error creating family account:", error);
                showPmrError('Failed to add family member. Please try again.');
            });
    };

    return (
        <div className="content-wrapper container-xxl p-0 mt-5">
            <div className="content-body">
                <section id="page-account-settings">
                    <h2 className='content-header-title float-left mb-4 text-capitalize'>Account Settings </h2>
                    <div className="row nav-vertical d-flex">
                        <div className="col-md-3 mb-2 mb-md-0">
                            <ul className="nav nav-pills flex-column nav-left">
                                <li className="nav-item">
                                    <a
                                        className={`nav-link activeclass d-flex align-items-center py-75 ${activeTab === 'general' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('general')}
                                        style={{ cursor: 'pointer', color: activeTab === 'general' ? 'white' : 'var(--pmr-text-heading)' }}
                                    >
                                        <User className="font-medium-3 mr-1 me-3 w-8 h-5" />
                                        <span className="fw-bold">General</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link activeclass d-flex align-items-center py-75 ${activeTab === 'address' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('address')}
                                        style={{ cursor: 'pointer', color: activeTab === 'address' ? 'white' : 'var(--pmr-text-heading)' }}
                                    >
                                        <Info className="font-medium-3 mr-1 me-3 w-8 h-5" />
                                        <span className="fw-bold">Address Information</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link activeclass d-flex align-items-center py-75 ${activeTab === 'family' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('family')}
                                        style={{ cursor: 'pointer', color: activeTab === 'family' ? 'white' : 'var(--pmr-text-heading)' }}
                                    >
                                        <Users className="font-medium-3 mr-1 me-3 w-8 h-5" />
                                        <span className="fw-bold">Family</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`nav-link activeclass d-flex align-items-center py-75 ${activeTab === 'security' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('security')}
                                        style={{ cursor: 'pointer', color: activeTab === 'security' ? 'white' : 'var(--pmr-text-heading)' }}
                                    >
                                        <Shield className="font-medium-3 mr-1 me-3 w-8 h-5" />
                                        <span className="fw-bold">Security</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-12 col-md-9">
                            {activeTab === 'general' && (
                                <div>
                                    <Card className="general-card" style={{ height: '20%' }}>
                                        <Card.Body>
                                            <div className="flex items-start space-x-4 d-flex justify-content-start align-items-center">
                                                <button
                                                    type="button"
                                                    onClick={handleAvatarPreview}
                                                    className="border-0 bg-transparent p-0 block"
                                                    aria-label="Preview profile image"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <img
                                                        src={avatarImage}
                                                        alt="profile"
                                                        className="rounded mr-2"
                                                        width={80}
                                                        height={76}
                                                    />
                                                </button>

                                                <div className="mt-2 ms-4">
                                                    <button
                                                        type="button"
                                                        onClick={handleUploadClick}
                                                        className="btn btn-primary text-white px-4 py-1 rounded text-sm mb-2"
                                                        disabled={isUploading}
                                                    >
                                                        {isUploading ? 'Uploading...' : 'Upload'}
                                                    </button>
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        onChange={handleUpload}
                                                        accept="image/jpeg,image/png,image/gif"
                                                        style={{ display: 'none' }}
                                                    />
                                                    <p className="text-sm text-gray-500 fw-bold">Allowed JPG, GIF or PNG. Max size of 800kB</p>
                                                </div>
                                            </div>
                                            <Form onSubmit={handleGeneralSubmit} autoComplete="off">
                                                <div className="row mb-3">
                                                    <div className="col-12 col-md-6">
                                                        <Form.Group controlId="first_name">
                                                            <Form.Label className='fw-bold'>First Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="first_name"
                                                                placeholder="Firstname"
                                                                value={generalForm.first_name}
                                                                onChange={handleGeneralChange}
                                                                isInvalid={generalSubmitted && !generalForm.first_name}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <Form.Group controlId="last_name">
                                                            <Form.Label className='fw-bold'>Last Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="last_name"
                                                                placeholder="Lastname"
                                                                value={generalForm.last_name}
                                                                onChange={handleGeneralChange}
                                                                isInvalid={generalSubmitted && !generalForm.last_name}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                                <div className="row py-1">
                                                    {/* Gender */}
                                                    <div className="col-md-4 mb-3">
                                                        <Form.Group controlId="gender">
                                                            <Form.Label className='fw-bold'>Gender</Form.Label>
                                                            <PmrSelect
                                                                name="gender"
                                                                value={generalForm.gender}
                                                                onChange={(value) => handleGeneralChange({ target: { name: 'gender', value } })}
                                                                options={PROFILE_GENDER_OPTIONS}
                                                                placeholder="Please select your gender"
                                                                isInvalid={generalSubmitted && !generalForm.gender}
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <Form.Group controlId="date_of_birth">
                                                            <Form.Label className='fw-bold'>Date of Birth</Form.Label>
                                                            <Flatpickr
                                                                name="pmr_profile_dob"
                                                                value={parseDobForPicker(generalForm.date_of_birth)}
                                                                onChange={(selectedDates, dateStr) => {
                                                                    setGeneralForm(prev => ({
                                                                        ...prev,
                                                                        date_of_birth: dateStr || ''
                                                                    }));
                                                                }}
                                                                placeholder="MM/DD/YYYY"
                                                                className="form-control w-100"
                                                                style={{
                                                                    height: '42px'
                                                                }}
                                                                autoComplete="off"
                                                                options={{
                                                                    dateFormat: "m/d/Y",
                                                                    allowInput: false,
                                                                    clickOpens: true,
                                                                    maxDate: new Date(),
                                                                    disableMobile: true,
                                                                    onReady: (_selectedDates, _dateStr, instance) => {
                                                                        const input = instance.input;
                                                                        if (!input) return;
                                                                        input.setAttribute('autocomplete', 'off');
                                                                        input.setAttribute('autocorrect', 'off');
                                                                        input.setAttribute('autocapitalize', 'off');
                                                                        input.setAttribute('spellcheck', 'false');
                                                                        // readonly blocks browser autocomplete but keeps Flatpickr calendar working
                                                                        input.setAttribute('readonly', 'readonly');
                                                                    },
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <Form.Group controlId="phone" className="account-settings-phone-group">
                                                            <Form.Label className='fw-bold'>Phone Number</Form.Label>
                                                            <div className="position-relative">
                                                                <div
                                                                    className={`signup-phone-combined ${(!generalPhoneValidation.isValid && generalSubmitted) ? 'is-invalid' : ''}`}
                                                                >
                                                                    <PmrSelect
                                                                        name="phone_country_code"
                                                                        value={generalForm.phone_country_code}
                                                                        onChange={(value) => handleGeneralChange({ target: { name: 'phone_country_code', value } })}
                                                                        options={countryCodeOptions}
                                                                        placeholder="+1"
                                                                        embedded
                                                                        isSearchable
                                                                        aria-label="Country code"
                                                                    />
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="phone"
                                                                        placeholder="Phone number"
                                                                        value={generalForm.phone}
                                                                        onChange={handleGeneralChange}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === ' ') e.preventDefault();
                                                                        }}
                                                                        inputMode="numeric"
                                                                        maxLength={10}
                                                                        autoComplete="tel-national"
                                                                        className="signup-phone-number-input"
                                                                    />
                                                                </div>
                                                                {(!generalPhoneValidation.isValid && generalSubmitted) && (
                                                                    <span className="signup-field-validation-icon text-danger">
                                                                        <i className="bi bi-exclamation-circle"></i>
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {(!generalPhoneValidation.isValid && generalSubmitted) && (
                                                                <div className="invalid-feedback d-block fw-bold" style={{ color: 'var(--pmr-danger)', fontSize: '0.75rem' }}>{generalPhoneValidation.message}</div>
                                                            )}
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                                 <div className="row mb-3">
                                                    <div className="col-12 col-md-6">
                                                        <Form.Group controlId="alternate_email">
                                                            <Form.Label className='fw-bold'>Alternate Email</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                inputMode="email"
                                                                autoComplete="email"
                                                                name="alternate_email"
                                                                placeholder="Alternate Email"
                                                                value={generalForm.alternate_email}
                                                                onChange={handleGeneralChange}
                                                                isInvalid={
                                                                    generalSubmitted &&
                                                                    !!generalForm.alternate_email &&
                                                                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(generalForm.alternate_email)
                                                                }
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please enter a valid email address.
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                </div> 
                                                <Button type="submit" className="mt-2 text-sm">Save changes</Button>
                                                <Button type="button" className="mt-2 account-settings-cancel-btn ms-3" onClick={handleCancle}>Cancel</Button>
                                            </Form>
                                        </Card.Body>
                                    </Card>

                                </div>
                            )}

                            {activeTab === 'address' && (
                                <div>
                                    <Card style={{ height: '20%' }}>
                                        <Card.Body>
                                            <Form onSubmit={handleAddressSubmit}>
                                                <div className="row mb-3">
                                                    <div className="col-12 col-md-6">
                                                        <Form.Group controlId="address1">
                                                            <Form.Label className='fw-bold'>Address Line 1</Form.Label>
                                                            <textarea
                                                                className={`form-control${addressSubmitted && !addressForm.address1 ? ' is-invalid' : ''}`}
                                                                name="address1"
                                                                placeholder="Address Line 1"
                                                                value={addressForm.address1}
                                                                onChange={handleAddressChange}
                                                                style={{ height: '130px' }}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <Form.Group controlId="address2">
                                                            <Form.Label className='fw-bold'>Address Line 2</Form.Label>
                                                            <textarea
                                                                className="form-control"
                                                                name="address2"
                                                                placeholder="Address Line 2"
                                                                value={addressForm.address2}
                                                                onChange={handleAddressChange}
                                                                rows={3}
                                                                style={{ height: '130px' }}
                                                            />
                                                            {/* No validation for address2 */}
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                                <div className="row py-1">
                                                    <div className="col-md-3 mb-3">
                                                        <Form.Group controlId="city">
                                                            <Form.Label className='fw-bold'>City</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="city"
                                                                placeholder="City"
                                                                value={addressForm.city}
                                                                onChange={handleAddressChange}
                                                                className={addressSubmitted && !addressForm.city ? 'is-invalid' : ''}
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-3 mb-3">
                                                        <Form.Group controlId="state">
                                                            <Form.Label className='fw-bold'>State</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="state"
                                                                placeholder="State"
                                                                value={addressForm.state}
                                                                onChange={handleAddressChange}
                                                                className={addressSubmitted && !addressForm.state ? 'is-invalid' : ''}
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-3 mb-3">
                                                        <Form.Group controlId="zip">
                                                            <Form.Label className='fw-bold'>Zip</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="zip"
                                                                placeholder="Zip"
                                                                value={addressForm.zip}
                                                                onChange={handleAddressChange}
                                                                className={addressSubmitted && !addressForm.zip ? 'is-invalid' : ''}
                                                            />
                                                        </Form.Group>
                                                    </div>

                                                    <div className="col-md-3 mb-3">
                                                        <Form.Group controlId="country">
                                                            <Form.Label className='fw-bold'>Country</Form.Label>
                                                            <div style={selectWrapperStyles}>
                                                                <Form.Control
                                                                    as="select"
                                                                    name="country"
                                                                    value={addressForm.country}
                                                                    onChange={handleAddressChange}
                                                                    className={addressSubmitted && !addressForm.country ? 'is-invalid' : ''}
                                                                    style={selectStyles}
                                                                >
                                                                    <option value="">Select Country</option>
                                                                    <option value="USA">USA</option>
                                                                    <option value="India">India</option>
                                                                    <option value="Canada">Canada</option>
                                                                </Form.Control>
                                                                <FaChevronDown style={iconStyles} />
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                                <Button type="submit" className="mt-2 text-sm">Save changes</Button>
                                                <Button type="button" className="mt-2 account-settings-cancel-btn ms-3" onClick={handleCancle}>Cancel</Button>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </div>
                            )}

                            {activeTab === 'family' && (
                                <div>
                                    <Card style={{ height: '60%' }}>
                                        <Card.Body>
                                            <div className="ag-theme-alpine mb-3" style={{ height: '420px', overflowY: 'auto' }}>
                                                <AgGridReact
                                                    rowData={accountSettings}
                                                    columnDefs={familyColumns}
                                                    enableBrowserTooltips={true}
                                                    tooltipShowDelay={0}
                                                    defaultColDef={{
                                                        sortable: true,
                                                        filter: true,
                                                        resizable: true,
                                                        minWidth: 100,
                                                        headerClass: 'custom-header-class'
                                                    }}
                                                    headerHeight={35}
                                                    enableCellTextSelection={true}
                                                    suppressRowClickSelection={true}
                                                    rowSelection="multiple"
                                                    className="ag-theme-alpine custom-grid"
                                                    rowClass={(params) => {
                                                        return params.rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
                                                    }}
                                                    getRowStyle={(params) => {
                                                        return {
                                                            backgroundColor: params.rowIndex % 2 === 0 ? 'var(--pmr-bg)' : 'var(--pmr-white)',
                                                            border: 'none',
                                                            borderBottom: '1px solid var(--pmr-border)'
                                                        };
                                                    }}
                                                />
                                            </div>

                                            <Form onSubmit={handleSaveChanges}>
                                                <div className="row mb-4">
                                                    <div className="col-12 col-md-6">
                                                        <Form.Group controlId="patient_name">
                                                            <Form.Label className='fw-bold' style={{
                                                                color: 'var(--pmr-text-heading)',
                                                                fontSize: '0.857rem'
                                                            }}>Select Family Member</Form.Label>
                                                            <div style={{ position: 'relative', width: '100%' }}>
                                                                <Select
                                                                    classNamePrefix="pmr-select"
                                                                    options={familyOptions}
                                                                    name="patient_name"
                                                                    value={familyOptions.find(option => option.value === familyForm.patient_id) || null}
                                                                    onChange={(selectedOption) => {
                                                                        setFamilyForm(prev => ({
                                                                            ...prev,
                                                                            patient_id: selectedOption ? selectedOption.value : '',
                                                                            patient_name: selectedOption ? selectedOption.label : ''
                                                                        }));
                                                                        setFamilySearchInput('');
                                                                    }}
                                                                    inputValue={familySearchInput}
                                                                    onInputChange={(inputValue, actionMeta) => {
                                                                        if (actionMeta.action === 'input-change') {
                                                                            setFamilySearchInput(inputValue);
                                                                        }
                                                                        return inputValue;
                                                                    }}
                                                                    filterOption={(option, inputValue) => {
                                                                        const searchValue = inputValue.trim().toLowerCase();
                                                                        if (searchValue.length < MIN_FAMILY_MEMBER_SEARCH_LENGTH) {
                                                                            return false;
                                                                        }
                                                                        return option.label.toLowerCase().includes(searchValue);
                                                                    }}
                                                                    styles={{
                                                                        ...customStyles,
                                                                        placeholder: (provided) => ({
                                                                            ...provided,
                                                                            color: 'var(--pmr-text-muted)',
                                                                            fontSize: '14px'
                                                                        })
                                                                    }}
                                                                    menuPlacement="top"
                                                                    menuPortalTarget={document.body}
                                                                    menuIsOpen={familySearchInput.trim().length >= MIN_FAMILY_MEMBER_SEARCH_LENGTH ? undefined : false}
                                                                    placeholder="Select Family Member"
                                                                    isInvalid={familySubmitted && !familyForm.patient_id}
                                                                    isSearchable={true}
                                                                    isClearable={true}
                                                                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                                                    noOptionsMessage={() => familySearchInput.trim().length < MIN_FAMILY_MEMBER_SEARCH_LENGTH ? "Type at least 3 characters to search" : "No family members found"}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <Form.Group controlId="relation">
                                                            <Form.Label className='fw-bold' style={{
                                                                color: 'var(--pmr-text-heading)',
                                                                fontSize: '0.857rem'
                                                            }}>Select Relation</Form.Label>
                                                            <div style={selectWrapperStyles}>
                                                                <Select
                                                                    classNamePrefix="pmr-select"
                                                                    options={relationOptions}
                                                                    name="relation"
                                                                    value={relationOptions.find(option => option.value === familyForm.relation) || null}
                                                                    onChange={(selectedOption) => {
                                                                        setFamilyForm(prev => ({
                                                                            ...prev,
                                                                            relation: selectedOption ? selectedOption.value : ''
                                                                        }));
                                                                    }}
                                                                    styles={customStyles}
                                                                    menuPlacement="top"
                                                                    menuPortalTarget={document.body}
                                                                    placeholder="Select Relation"
                                                                    isInvalid={familySubmitted && !familyForm.relation}
                                                                    isSearchable={false}
                                                                    components={{ IndicatorSeparator: () => null }}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                                <Button type="submit" className="mt-2 text-sm">Save changes</Button>
                                                <Button type="button" className="mt-2 account-settings-cancel-btn ms-3" onClick={handleCancle}>Cancel</Button>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </div>
                            )}

                            <div hidden={activeTab !== 'security'}>
                                <PasskeyRegisterCard
                                    userName={userData?.user_name || userData?.email_address}
                                    emailAddress={userData?.email_address || userData?.user_name}
                                    userId={userData?.user_id || userData?.UserID}
                                    token={token || userData?.Token || userData?.token}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {showFamilyModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-content">
                        <div className="custom-modal-icon">
                            <svg width="80" height="80" viewBox="0 0 80 80">
                                <circle cx="40" cy="40" r="38" stroke="#B7E2C1" strokeWidth="4" fill="none" />
                                <path d="M25 40l12 12 18-22" stroke="#6FCF97" strokeWidth="4" fill="none" />
                            </svg>
                        </div>
                        <div className="custom-modal-message">
                            {familyModalMessage}
                        </div>
                        <button className="custom-modal-ok-btn" onClick={() => setShowFamilyModal(false)}>
                            OK
                        </button>
                    </div>
                </div>
            )}

            {/* Family Action Modal */}
            <FamilyActionModal
                show={showActionModal}
                onHide={() => setShowActionModal(false)}
                rowData={selectedFamilyData}
                onApprove={handleApprove}
                onReject={handleReject}
                isProcessing={isProcessingAction}
            />
        </div>
    );
};

export default AccountSettings;
